/// <reference types="bootstrap"/>
import { Collapse } from './../collapse';
import { Backdrop } from './../backdrop';
import { ScrollBarHelper } from './../scrollbar-helper';
import { ScrollSpy } from './../scrollspy';
class CollapseMenu extends Collapse {
    run() {
        super.run();
        this.initBackdrop();
        this.initScrollBarHelper();
        this.ScrollSpy();
        this.initListeners();
    }
    initBackdrop() {
        this.backdrop = new Backdrop({});
    }
    initScrollBarHelper() {
        this.scrollBarHelper = new ScrollBarHelper({});
    }
    ScrollSpy() {
        this.scrollSpy = new ScrollSpy({ element: document.body });
    }
    initListeners() {
        this.config.element.addEventListener('hidden.bs.collapse', event => {
            this.scrollBarHelper.reset();
            this.backdrop.hide();
        });
        this.config.element.addEventListener('shown.bs.collapse', event => {
            this.scrollBarHelper.hide();
            this.backdrop.show();
        });
    }
}
export { CollapseMenu };
